
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { SystemUserInterface, SystemUserRepositoryInterface } from '@/services/SystemUsers/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'systemUserRepository',
  ],
})
export default class DeleteSystemUserDialog extends Vue {
  @Prop() private readonly systemUser: SystemUserInterface;
  private systemUserRepository!: SystemUserRepositoryInterface;
  private visible: boolean = true;

  get message(): string {
    return `Are you sure you want to delete system user '${this.systemUser.name}'?`;
  }


  private async deleteSystemUser(): Promise<void> {
    try {
      await this.systemUserRepository.deleteSystemUser(this.systemUser.id);
      this.$successDialog.show(`System User '${this.systemUser.name}' deletion started!`);
      this.$emit('system-user-deleted', this.systemUser);
      this.destroyComponent();
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message || e.message);
    }
  }

  private destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }
}
